

class Storage {
  static instance = null;

  static getInstance() {
    if (!Storage.instance) {
      Storage.instance = new Storage();
    }
    return Storage.instance;
  }

  object = {};
  initialized = false;
  localStorageSupported = false;

  constructor() {
    try {
      localStorage.setItem('localStorage.supported', 'true');
      localStorage.removeItem('localStorage.supported');

      this.localStorageSupported = true;
    } catch (e) {
      this.localStorageSupported = false;
    }

    if(this.localStorageSupported){
      for (const key in localStorage){
        this.object[key] = localStorage.getItem(key);
      }
    }
  }

  setItem = (key, value) => {
    this.object[key] = value;

    if(this.localStorageSupported){
      localStorage[key] = value;
    }

    return this.object[key];
  };

  getItem = key => this.object[key];

  clear = () => {
    if(this.localStorageSupported){
      this.object = {};
    }

    localStorage.clear();
  };

  remove = key => {
    delete this.object[key];

    if(this.localStorageSupported){
      localStorage.removeItem(key);
    }
  };
}

export default Storage.getInstance();
